import React, { useContext, useState } from 'react';
import { ConquerContext } from '../../contexts/ConquerContext';
import styles from './NHome.module.sass';
import GamesGrid from '../../components/Games/GamesGrid';
import GameChat from '../Game/GameChat';
import GameInjector from '../Game/GameInjector';
import { GameContext } from '../../contexts/GamesContext';
import { UserContext } from '../../contexts/UserContext';
import CONFIG from '../../../Core/CONFIG/CONFIG';
import { useEffect } from 'react';
import Hero from '../Game/Hero';
import { withRouter } from 'react-router';

const NHome = ({history}) => {

    const userData = useContext( UserContext );
    const {show,hide} = useContext( GameContext );
    const conquer = useContext( ConquerContext );
    const [gamesData, setGamesData] = useState([]);
    const [randomGame, setRandomGame] = useState( {} );

    useEffect(() => {
        
        const LoadGames = async function(){

            let games = await conquer.Games.get();
            setGamesData( games );
    
            setRandomGame( games[Math.floor(Math.random()*games.length)] );
    
        };
        LoadGames();
        console.log('Verified');

    }, []);

	const onGameExit = () => { conquer.Sounds.stop() };

	const onGameClick = (gameData) => {

		conquer.Sounds.stop();
        // show( {gameKey: gameData.gameKey, clear: true, onCloseCallback: onGameExit} );
        history.push( '/game/' + gameData.gameKey );


	}

    return <>
        {/* <div className={styles.gameContainer}>
            <img src={'https://nowwa.io/items/645bd015cb3c98d372494751/COLLAPSE_SplashLandscape.png'}/>
            <button className='button' onClick={() => { onGameClick(randomGame) }}>Join</button>
        </div> */}
        <Hero game={randomGame} onGameClick={() => { onGameClick(randomGame) }}/>
        <h2 className={styles.trending}>TRENDING</h2>
        <h1 className={styles.trendingTitle}>#EarlyAccess</h1>
        <div className={styles.gamesGrid}><GamesGrid gamesData={gamesData} onGameClick={onGameClick}/></div>
        {/* {userData.userData.isLogged && <GameChat gameKey={'Home'}/>} */}
    </>
};

export default withRouter(NHome);
